import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

function ResourceSchedulePage() {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {};
  }, [dispatch]);

  return null;
}

export default ResourceSchedulePage;
